import React from 'react'
import DropDownFilter from './dropdown-filter'
import useDimensions from '../../../hooks/use-dimensions'
import { get } from 'lodash'

const DimensionsFilter = ({
    value = {},
    onChange = () => {},
    disabled
}) => {
    const [ dimensions ] = useDimensions()
    return (
        <React.Fragment>
            <DropDownFilter
                items={dimensions}
                title='Dimension'
                onChange={l => onChange({ ...value, dimensions: l})}
                values={get(value, 'dimensions', [])}
                disabled={disabled}
            />
        </React.Fragment>
    )
}

export default DimensionsFilter